import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";

export const teamUrl = (team: GetOneTeamResponse, url: string) => {
	let cleanUrl = "";
	if (url.startsWith("/")) {
		cleanUrl = url.substr(1);
	}

	if (team.guildNameSlug) {
		return `/${team.guildRegion}/${team.guildRealmSlug}/${team.guildNameSlug}/${cleanUrl}`;
	}
	else {
		return `/t/${team.slug}/${cleanUrl}`;
	}
};